import * as React from 'react';

import {TypeImplementation, Plugins} from '@packages/systems/wfdl';
import {ELiteral} from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Checkbox} from '@packages/systems/spring';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';
import {getBoolean} from '@packages/utilities/json';

const createLiteralExpr = (value: boolean) =>
  ELiteral({
    name: qualify(Plugins.name('Animation'), typeName('RiveAutoPlay')),
    value,
  });

export const autoPlay = TypeImplementation.Custom({
  render: function AutoPlayCheckbox({dispatch, expr}) {
    const literal = ContextualExpressions.getLiteral(stripAnn(expr));
    const state = literal ? getBoolean(literal.value) : undefined;

    return (
      <Checkbox
        data-automation-id="rive-autoplay-checkbox"
        label="Autoplay"
        isChecked={state}
        onChange={() =>
          dispatch(updateExpressionAction(createLiteralExpr(!state)))
        }
      />
    );
  },
  system: {
    labelVariant: 'hidden',
    defaultValue: false,
  },
});
